// Example structure - add all countries you support

export const countries = [
  { code: 'canada', label: 'Canada', flag: 'https://flagcdn.com/ca.svg' },
  // Add more as needed
];